import { isObject } from "@trpc/server/unstable-core-do-not-import";

//#region src/TRPCClientError.ts
function isTRPCClientError(cause) {
	return cause instanceof TRPCClientError;
}
function isTRPCErrorResponse(obj) {
	return isObject(obj) && isObject(obj["error"]) && typeof obj["error"]["code"] === "number" && typeof obj["error"]["message"] === "string";
}
function getMessageFromUnknownError(err, fallback) {
	if (typeof err === "string") return err;
	if (isObject(err) && typeof err["message"] === "string") return err["message"];
	return fallback;
}
var TRPCClientError = class TRPCClientError extends Error {
	cause;
	shape;
	data;
	/**
	* Additional meta data about the error
	* In the case of HTTP-errors, we'll have `response` and potentially `responseJSON` here
	*/
	meta;
	constructor(message, opts) {
		const cause = opts?.cause;
		super(message, { cause });
		this.meta = opts?.meta;
		this.cause = cause;
		this.shape = opts?.result?.error;
		this.data = opts?.result?.error.data;
		this.name = "TRPCClientError";
		Object.setPrototypeOf(this, TRPCClientError.prototype);
	}
	static from(_cause, opts = {}) {
		const cause = _cause;
		if (isTRPCClientError(cause)) {
			if (opts.meta) cause.meta = {
				...cause.meta,
				...opts.meta
			};
			return cause;
		}
		if (isTRPCErrorResponse(cause)) return new TRPCClientError(cause.error.message, {
			...opts,
			result: cause
		});
		return new TRPCClientError(getMessageFromUnknownError(cause, "Unknown error"), {
			...opts,
			cause
		});
	}
};

//#endregion
export { TRPCClientError, isTRPCClientError };
//# sourceMappingURL=TRPCClientError-COkhCKf3.mjs.map